import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Text from './Text';
import Button from './Button';
import { Dialog, DialogActions } from './Dialog';
import { values } from './utils';
export var CONFIRM_ACTION_TYPES = {
  PRIMARY: 'primary',
  DESTRUCTIVE: 'destructive'
};

var ConfirmDialog = function ConfirmDialog(_ref) {
  var confirmActionType = _ref.confirmActionType,
      confirmButtonLabel = _ref.confirmButtonLabel,
      cancelButtonLabel = _ref.cancelButtonLabel,
      dialogTitle = _ref.dialogTitle,
      dialogBody = _ref.dialogBody,
      onCancel = _ref.onCancel,
      onConfirm = _ref.onConfirm,
      onClose = _ref.onClose,
      isOpen = _ref.isOpen;
  var inputEl = useRef();

  var focusButton = function focusButton() {
    inputEl.current.focus();
  };

  return React.createElement(Dialog, {
    "data-testid": "confirm-dialog",
    hideCloseButton: true,
    disableBackdropClick: true,
    onEnter: focusButton,
    title: dialogTitle,
    isOpen: isOpen,
    onClose: onClose
  }, React.createElement(Text, {
    color: "text"
  }, dialogBody), React.createElement(DialogActions, null, React.createElement(Button, {
    onClick: onCancel
  }, cancelButtonLabel), React.createElement(Button, {
    ref: inputEl,
    variant: confirmActionType,
    onClick: onConfirm
  }, confirmButtonLabel)));
};

ConfirmDialog.defaultProps = {
  confirmActionType: CONFIRM_ACTION_TYPES.PRIMARY,
  confirmButtonLabel: 'Confirm',
  cancelButtonLabel: 'Cancel',
  dialogTitle: 'Please Confirm',
  dialogBody: 'Please take a moment to confirm you wish to perform this action.',
  onCancel: function onCancel() {},
  onConfirm: function onConfirm() {},
  onClose: function onClose() {},
  isOpen: false
};
export default ConfirmDialog;